import type { DirectiveBinding, ObjectDirective } from 'vue';

let storage: any;

/**
 * Сохранить данные в элементе
 *
 * Для доступа к данным можно воспользоваться ui/utils/dom storage()
 */
const data = {
	mounted: async (el: HTMLElement, binding: DirectiveBinding) => {
		if (!storage) {
			const UtilsDom = await import('@/core/utils/dom');

			storage = UtilsDom.storage;
		}

		const name = binding.arg;
		const value = binding.value;

		storage(el, name, value);
	},
};

export default data;
